import { IVignetteRangesTableData } from '.';
import { IAbstractRecord } from '@models';
import { IListingData } from '@models/listing';
import { capitalizeFirstLetter } from '@utils/formatting-utils';

export function mapToVignetteRangeListingData(
  data: IAbstractRecord
): IListingData {
  const list: IAbstractRecord = {};

  data?.SalesforceManagement?.queries?.getBusinessPartnerVignetteRange?.items?.forEach(
    (obj: IVignetteRangesTableData) => {
      list[obj.salesforceManagement_BusinessPartnerVignetteRange_Id] = {
        salesforceManagement_BusinessPartnerVignetteRange_Id:
          obj.salesforceManagement_BusinessPartnerVignetteRange_Id,
        salesforceManagement_BusinessPartnerVignetteRange_BusinessPartnerID:
          obj
            .salesforceManagement_BusinessPartnerVignetteRange_BusinessPartnerID
            ?.id,
        salesforceManagement_BusinessPartnerVignetteRange_RangeFrom:
          obj.salesforceManagement_BusinessPartnerVignetteRange_RangeFrom,
        salesforceManagement_BusinessPartnerVignetteRange_RangeTo:
          obj.salesforceManagement_BusinessPartnerVignetteRange_RangeTo,
        salesforceManagement_BusinessPartnerVignetteRange_RangeStatus:
          capitalizeFirstLetter(
            obj.salesforceManagement_BusinessPartnerVignetteRange_RangeStatus
          ),
        salesforceManagement_BusinessPartnerVignetteRange_RangeYear:
          obj.salesforceManagement_BusinessPartnerVignetteRange_RangeYear,
        salesforceManagement_BusinessPartnerVignetteRange_RangeCode:
          obj.salesforceManagement_BusinessPartnerVignetteRange_RangeCode,
      };
    }
  );

  return {
    pagedItems: list,
    pageSize:
      data.SalesforceManagement.queries.getBusinessPartnerVignetteRange.paging
        .pageSize,
    pageNumber:
      data.SalesforceManagement.queries.getBusinessPartnerVignetteRange.paging
        .pageNumber,
    totalCount:
      data.SalesforceManagement.queries.getBusinessPartnerVignetteRange.paging
        .totalCount,
  };
}
